import { apiFetch, type RequestAuth } from './client';

/** rivendell `GET /dev-portal/api-keys` — whether the developer has a key. */
export interface ApiKeyStatus {
  hasKey: boolean;
}

/** rivendell `POST /dev-portal/api-keys` — the plaintext key, returned once. */
export interface GeneratedApiKey {
  plaintextKey: string;
}

export function getApiKeyStatus(auth: RequestAuth): Promise<ApiKeyStatus> {
  return apiFetch<ApiKeyStatus>('/dev-portal/api-keys', auth);
}

export function generateApiKey(auth: RequestAuth): Promise<GeneratedApiKey> {
  return apiFetch<GeneratedApiKey>('/dev-portal/api-keys', auth, { method: 'POST' });
}
